import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addReplenishment from "./components/addReplenishment.vue";
import { tabulation, Kamitaku } from "@/mixins/index";
import { loginRechargeData, loginRechargeData_currency, replenishmentSelect } from "@/api/kamitaku/kamitaku";
export default {
  name: "kamitakuTopup",
  mixins: [tabulation, Kamitaku],
  components: {
    addReplenishment: addReplenishment
  },
  data: function data() {
    return {
      more: true,
      reqFn: loginRechargeData,
      searchData: {},
      Replenishment: [],
      drawer: false,
      ReplenishmentColumn: [{
        label: this.$t('game'),
        prop: 'game',
        width: 160
      }, {
        label: this.$t('platform'),
        prop: 'platform',
        width: 120
      }, {
        label: this.$t('channel'),
        prop: 'channel',
        width: 120
      }, {
        label: this.$t('pkg'),
        prop: 'pkg',
        width: 200
      }, {
        label: this.$t('serverId'),
        prop: 'server_id',
        width: 120
      }, {
        label: this.$t('deviceId'),
        prop: 'device_id',
        width: 160
      }, {
        label: this.$t('accountId'),
        prop: 'user_id',
        width: 100
      }, {
        label: this.$t('roleId'),
        prop: 'role_id',
        width: 100
      }, {
        label: this.$t('orderNo'),
        prop: 'order_id',
        width: 160
      }, {
        label: this.$t('level'),
        prop: 'level',
        width: 80
      }, {
        label: this.$t('amountInCents'),
        prop: 'amount',
        width: 100
      }, {
        label: this.$t('currencyType'),
        prop: 'currency',
        width: 100
      }, {
        label: this.$t('productId'),
        prop: 'product_id',
        width: 160
      }, {
        label: this.$t('productName'),
        prop: 'product_name',
        width: 160
      }, {
        label: this.$t('rechargeUserIp'),
        prop: 'ip',
        width: 160
      }, {
        label: this.$t('rechargeTime'),
        prop: 'timestamp',
        width: 180
      }]
    };
  },
  created: function created() {},
  methods: {
    getListnew: function getListnew() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // if(this.currencyClose && !this.searchData.currency_info){
                //   this.$message.error('请选择货币类型')
                //   return
                // }
                _this.reqFn = _this.currencyClose ? loginRechargeData_currency : loginRechargeData;
                _context.next = 3;
                return _this.getexchangeRate();

              case 3:
                _this.searchData = _objectSpread(_objectSpread({}, _this.searchData), _this.defaultData());

                _this.getList(function (res) {
                  // this.tabData = {
                  //   "2025-01-30": {
                  //     "login_num": 4485,
                  //     "recharge_num": 3383200
                  //   },
                  //   "2025-01-31": {
                  //     "login_num": 4373,
                  //     "recharge_num": 2666600
                  //   }
                  // }
                  var totalNum = 0;
                  var totalMoney = 0;
                  var totalexchange = 0;

                  for (var key in _this.tabData) {
                    _this.tabData[key].recharge_numexchange = _this.isyjfmvnd() ? (Number(_this.tabData[key].recharge_num) * _this.exchangeRate).toFixed(3) : _this.$utils.conversion(Number(_this.tabData[key].recharge_num) * _this.exchangeRate).toFixed(3);
                    _this.tabData[key].recharge_num = _this.isyjfmvnd() ? _this.tabData[key].recharge_num : _this.$utils.conversion(_this.tabData[key].recharge_num);
                    totalNum += _this.tabData[key].login_num;
                    totalMoney += _this.tabData[key].recharge_num;
                    totalexchange += _this.tabData[key].recharge_numexchange;

                    _this.tableData.push(_objectSpread({
                      date: key
                    }, _this.tabData[key]));
                  }

                  _this.tableData.push({
                    date: _this.$t('total'),
                    login_num: totalNum,
                    recharge_num: totalMoney.toFixed(2),
                    recharge_numexchange: totalexchange.toFixed(2)
                  });
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    viewRecord: function viewRecord(scope) {
      var _this2 = this;

      var data = {
        game: this.searchData.game,
        platform: this.searchData.platform,
        channel: this.searchData.channel,
        game_id: this.searchData.game_id,
        pkg: this.searchData.pkg,
        country: this.searchData.country
      };
      replenishmentSelect(_objectSpread({
        date: scope.row.date
      }, data)).then(function (res) {
        if (res.status == 200) {
          if (res.data.length) {
            res.data.map(function (i) {
              i.timestamp = _this2.$times.timestampToTime(i.timestamp, 'YY-MM-DD H');
            });
            _this2.Replenishment = res.data;
            _this2.drawer = true;
          } else {
            _this2.$message({
              message: _this2.$t('noData')
            });
          }
        }
      });
    },
    exportTab: function exportTab() {
      var columns = [{
        label: this.$t('time'),
        prop: 'date'
      }, {
        label: this.$t('activeUsers'),
        prop: 'login_num'
      }, {
        label: this.$t('totalPayAmount'),
        prop: 'recharge_num'
      }];
      var exchangeUSD = [{
        label: this.$t('totalPayAmountVnd'),
        prop: 'recharge_numexchange'
      }];
      var exchangeVND = [{
        label: this.$t('totalPayAmountUsd'),
        prop: 'recharge_numexchange'
      }];

      if (this.queryCurrency == "USD") {// exchangeUSD.unshift(4, 0);
        // Array.prototype.splice.apply(columns, exchangeUSD);
      }

      if (this.queryCurrency == "VND") {
        exchangeVND.unshift(4, 0);
        Array.prototype.splice.apply(columns, exchangeVND);
      }

      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    },
    exportReplenishment: function exportReplenishment() {
      var columns = this.ReplenishmentColumn;
      var data = this.Replenishment;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};